export const AuthSidebarWidth = 296;
